import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { ReportTemplate, ReportTemplateFiltersResponse } from 'dashboard/models/report-template';
import {
  ReportTemplatesFilterParams,
  setReportTemplateFilterOptions,
  setReportTemplates,
} from 'dashboard/redux/actions/report-templates';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadReportTemplatesList({
  currentPage,
  pageSize,
  sortParams,
  filters,
  abortSignal,
}: {
  currentPage: number;
  pageSize: number;
  sortParams: SortParams;
  filters: ReportTemplatesFilterParams;
  abortSignal?: AbortSignal;
}) {
  return async (dispatch: Dispatch) => {
    const params = createParamsForList(filters, sortParams);
    const paramsFull = {
      ...params,
      page: {
        number: currentPage,
        size: pageSize,
      },
      signal: abortSignal,
    };

    const reportsResponse = await SessionClientDashboard.listResource<
      ReportTemplate,
      PaginationParams
    >(ApiEndpoint.ReportTemplate, paramsFull);

    const reportTemplates = reportsResponse.data;
    const paginationParams = reportsResponse.meta;

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setReportTemplates(reportTemplates, paginationParams));
  };
}

export function loadReportTemplatesForFilter() {
  return async (dispatch: Dispatch) => {
    const params = {
      page: {
        // use a large page size in case an organization has many templates
        size: 100,
      },
    };

    const reportTemplatesResponse = await SessionClientDashboard.listResource<
      ReportTemplate,
      PaginationParams
    >(ApiEndpoint.ReportTemplate, params);
    const reportTemplates = reportTemplatesResponse.data;

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setReportTemplates(reportTemplates, reportTemplatesResponse.meta));
  };
}

function createParamsForList(
  reportTemplateFilters: ReportTemplatesFilterParams,
  reportTemplateSortParams: SortParams,
) {
  const { createdAtStart, createdAtEnd, type, omni, status } = reportTemplateFilters;
  const { sort, shouldSortDescending } = reportTemplateSortParams;

  return {
    filter: {
      'created-at-start': createdAtStart?.toString(),
      'created-at-end': createdAtEnd?.toString(),
      type: type,
      omni: omni,
      status: status,
    },
    sort: `${shouldSortDescending ? '-' : ''}${sort}`,
  };
}

export const loadReportTemplatesFilterOptions = ({
  filters,
  sortParams,
}: {
  filters?: ReportTemplatesFilterParams;
  sortParams?: SortParams;
}): DashboardThunkAction<Promise<void>> => {
  return async (dispatch: Dispatch) => {
    const { meta } = await SessionClientDashboard.get<ReportTemplateFiltersResponse>(
      ApiEndpoint.ReportTemplate,
      'basics',
      '',
      {
        filter:
          filters == null
            ? undefined
            : {
                omni: filters.omni,
                status: filters.status,
                type: filters.type,
                accountId: filters.accountId,
              },
        sort:
          sortParams == null
            ? undefined
            : `${sortParams.shouldSortDescending ? '-' : ''}${sortParams.sort}`,
      },
    );

    dispatch(setReportTemplateFilterOptions(meta.filters));
  };
};
